export default __webpack_public_path__ + "static/media/graph.0953065d.png";